import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "14",
  viewBox: "0 0 10 14",
  fill: "none"
}
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pinIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M5.06377 0.291992C4.05301 0.291992 3.08366 0.693519 2.36895 1.40824C1.65424 2.12296 1.25272 3.09233 1.25272 4.1031V10.5657C1.23607 10.9425 1.29591 11.3187 1.42863 11.6718C1.56134 12.0248 1.76418 12.3473 2.02492 12.6198C2.28566 12.8923 2.59889 13.1092 2.94572 13.2574C3.29255 13.4056 3.6658 13.4819 4.04295 13.4819C4.42011 13.4819 4.79335 13.4056 5.14018 13.2574C5.48702 13.1092 5.80025 12.8923 6.06098 12.6198C6.32172 12.3473 6.52456 12.0248 6.65728 11.6718C6.78999 11.3187 6.84983 10.9425 6.83318 10.5657V5.57855C6.83318 5.10349 6.64447 4.64788 6.30855 4.31196C5.97264 3.97604 5.51704 3.78733 5.04199 3.78733C4.56694 3.78733 4.11134 3.97604 3.77543 4.31196C3.43951 4.64788 3.2508 5.10349 3.2508 5.57855V9.81977C3.2508 9.96416 3.30816 10.1026 3.41026 10.2048C3.51236 10.3069 3.65084 10.3642 3.79523 10.3642C3.93963 10.3642 4.07811 10.3069 4.18021 10.2048C4.28231 10.1026 4.33967 9.96416 4.33967 9.81977V5.57855C4.33967 5.39228 4.41366 5.21364 4.54537 5.08192C4.67708 4.95021 4.85572 4.87621 5.04199 4.87621C5.22826 4.87621 5.40689 4.95021 5.53861 5.08192C5.67032 5.21364 5.74431 5.39228 5.74431 5.57855V10.5657C5.75741 10.7972 5.72312 11.0289 5.64354 11.2468C5.56396 11.4646 5.44076 11.6638 5.28149 11.8324C5.12222 12.0009 4.93022 12.1352 4.71726 12.227C4.50429 12.3187 4.27484 12.3661 4.04295 12.3661C3.81106 12.3661 3.58161 12.3187 3.36864 12.227C3.15568 12.1352 2.96368 12.0009 2.80441 11.8324C2.64514 11.6638 2.52194 11.4646 2.44236 11.2468C2.36278 11.0289 2.32849 10.7972 2.34159 10.5657V4.1031C2.34159 3.38112 2.62839 2.68872 3.1389 2.1782C3.64941 1.66769 4.3418 1.38088 5.06377 1.38088C5.78573 1.38088 6.47813 1.66769 6.98863 2.1782C7.49914 2.68872 7.78594 3.38112 7.78594 4.1031V8.18644C7.78594 8.33083 7.8433 8.46931 7.9454 8.57142C8.0475 8.67352 8.18598 8.73088 8.33038 8.73088C8.47477 8.73088 8.61325 8.67352 8.71535 8.57142C8.81745 8.46931 8.87481 8.33083 8.87481 8.18644V4.1031C8.87481 3.09233 8.47329 2.12296 7.75858 1.40824C7.04387 0.693519 6.07452 0.291992 5.06377 0.291992Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ]))
}
}

})